/**
 * 日期相关的文本
 */
export default {
  dbl_date_day: '天',
  dbl_date_day_upper: '天',
  dbl_date_days: '天',
  dbl_date_day_last_current: '今天',
  dbl_date_day_today: '今天',
  dbl_date_day_last_1: '昨天',
  dbl_date_day_last_3: '最近3天',
  dbl_date_day_last_7: '最近7天',
  dbl_date_day_last_14: '最近14天',
  dbl_date_day_last_30: '最近30天',
  dbl_date_day_last: '最近{last}天',

  dbl_date_day_last_prefix: '最近{last}天',
  dbl_date_day_last_prefix_1: '最近1天',
  dbl_date_day_last_prefix_current: '今天',

  dbl_date_day_ago_current: '今天',
  dbl_date_day_ago_1: '昨天',
  dbl_date_day_ago_2: '2天前',
  dbl_date_day_ago_3: '3天前',
  dbl_date_day_ago_4: '4天前',
  dbl_date_day_ago: '{ago}天前',
  dbl_date_text_day_ago: '天前',

  dbl_date_week: '周',
  dbl_date_week_upper: '周',
  dbl_date_weeks: '周',
  dbl_date_week_last_current: '本周',
  dbl_date_week_last_1: '最近1周',
  dbl_date_week_last: '最近{last}周',
  dbl_date_week_last_prefix: '最近{last}周',
  dbl_date_week_last_prefix_1: '最近1周',
  dbl_date_week_last_prefix_current: '本周',
  dbl_date_week_ago_current: '本周',
  dbl_date_week_ago_1: '上周',
  dbl_date_week_ago_2: '2周前',
  dbl_date_week_ago_3: '3周前',
  dbl_date_week_ago_4: '4周前',
  dbl_date_week_ago: '{ago}周前',
  dbl_date_text_week_ago: '周前',

  dbl_date_month: '月',
  dbl_date_month_upper: '月',
  dbl_date_months: '月',
  dbl_date_month_last_current: '本月',
  dbl_date_month_last_1: '最近1月',
  dbl_date_month_last: '最近{last}月',
  dbl_date_month_last_prefix: '最近{last}月',
  dbl_date_month_last_prefix_1: '最近1月',
  dbl_date_month_last_prefix_current: '本月',
  dbl_date_month_ago_current: '本月',
  dbl_date_month_ago_1: '上月',
  dbl_date_month_ago_2: '2个月前',
  dbl_date_month_ago_3: '3个月前',
  dbl_date_month_ago_4: '4个月前',
  dbl_date_month_ago: '{ago}个月前',
  dbl_date_text_month_ago: '个月前',

  dbl_date_year: '今年',
  dbl_date_year_prefix: '今年',

  dbl_date_from: '（截至{from}）',
  
  dbl_date_hour: '小时',
  dbl_date_hours: '小时',
  dbl_date_hour_now: '今天至今',
  dbl_date_hour_current: '当前小时',
  dbl_date_hour_last_1: '最近1小时',
  dbl_date_hour_last_6: '最近6小时',
  dbl_date_hour_last_12: '最近12小时',
  dbl_date_hour_last_24: '最近24小时',
  dbl_date_hour_last_48: '最近48小时',
  dbl_date_hour_last: '最近{last}小时',
  dbl_date_hour_ago_current: '当前小时',
  dbl_date_hour_ago: '{ago}个小时前',
  dbl_date_text_hour_ago: '小时前',
  dbl_date_hour_ago_1: '上个小时',
  dbl_date_hour_ago_2: '2小时前',
  dbl_date_hour_ago_3: '3小时前',
  dbl_date_hour_last_prefix: '最近{last}小时',
  dbl_date_hour_last_prefix_1: '最近1小时',
  dbl_date_hour_last_prefix_current: '当前小时',
  dbl_date_ago: '前',
  
  // 时间对比设置
  dbl_time_compare_info_chart: '时间对比功能当前仅适用于折线图与事件折线图。',
  dbl_time_compare_info_dashboard: '时间对比功能当前仅适用于筛选器「生效范围」内的折线图与事件折线图。',
  dbl_time_compare_title: '时间对比',
  dbl_time_compare_label: '对比时间',
  dbl_time_compare_base: '基准时间',
  dbl_time_compare_custom_text_prefix: '基准时间的',
  dbl_time_compare_custom_info: '基于基准时间段(T)，以输入的数值作为偏移单位(n)，根据T-n计算出对比时间段。',
  dbl_time_compare_add_disabled: '最多支持4个对比时间',
  
  // 字符串下拉选时间筛选器
  dbl_time_all: '全部时间',
  dbl_time_last_datetype: '最近{lastCount}{dateType}',
  dbl_time_string_filter_label1: '时间范围',
  dbl_time_string_filter_label2: '时间字段',
  dbl_time_last_text: '最近',

  dbl_date_last_custom_info: '最小输入5',
};